export default "__VITE_ASSET__e29b34cf__"